import React from 'react';
import { SubAppLayout } from '../components/Layout/SubAppLayout';
import { UsersTable } from '../components/Admin/Users/UsersTable';
import { KnowledgeTab } from '../components/Admin/Knowledge/KnowledgeTab';

const menuItems = [
    { id: 'users', label: 'Users', component: UsersTable },
    { id: 'knowledge', label: 'Knowledge Base', component: KnowledgeTab },
];

export const AdminApp: React.FC = () => {
    return <SubAppLayout menuItems={menuItems} defaultSelectedId="users" />;
}; 